import { default as React, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import ExpiredTenantDialog from './ExpiredTenantDialog';
import { AuthType } from '@innovyze/stylovyze/lib/types';
import { getSubscriptionsUsageAction, getSubscriptionsUsageResolved, } from '@innovyze/stylovyze/lib/actions';
import { getAuthenticationProvider, populateEntitlementsToSubscriptions, } from '@innovyze/stylovyze/lib/utils';
import { useAccountSubscriptions } from '@innovyze/stylovyze/lib/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthenticationContext, selectEntitlements, } from '@innovyze/stylovyze/lib/selectors';
export default function ExpiredTenantDialogWrapper({ children, expiredSubscriptionsSet, }) {
    const dispatch = useDispatch();
    const { activeSubscriptions, initialized } = useAccountSubscriptions(expiredSubscriptionsSet);
    const [subscriptionsLoaded, setSubscriptionsLoaded] = useState(false);
    const featureEnabled = expiredSubscriptionsSet !== undefined;
    const { isInitializing } = useSelector(selectAuthenticationContext);
    const shouldLoadSettings = featureEnabled && !isInitializing && !subscriptionsLoaded;
    const [open, setOpen] = useState(false);
    const entitlements = useSelector(selectEntitlements);
    useEffect(() => {
        if (shouldLoadSettings) {
            if (getAuthenticationProvider() === AuthType.Forge) {
                const subscriptions = populateEntitlementsToSubscriptions(entitlements);
                dispatch(getSubscriptionsUsageResolved({ subscriptions }));
            }
            else {
                dispatch(getSubscriptionsUsageAction());
            }
            setSubscriptionsLoaded(true);
        }
    }, [shouldLoadSettings]);
    useEffect(() => {
        const hasActiveSubscriptions = activeSubscriptions.length > 0;
        setOpen(featureEnabled && !hasActiveSubscriptions);
    }, [activeSubscriptions]);
    return open ? (React.createElement(Switch, null,
        React.createElement(Route, { path: "/" },
            React.createElement(ExpiredTenantDialog, { open: true, loading: !initialized })))) : (children);
}
